export default __webpack_public_path__ + "static/media/product-4.58f90a04.webp";